var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 422,
    viewBox: "0 0 422 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_13812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.012 421.025C94.9625 421.025 0.5 326.562 0.5 210.512C0.5 94.4625 94.9625 0 211.012 0C327.062 0 421.525 94.4625 421.525 210.512C421.525 326.562 327.062 421.025 211.012 421.025ZM211.012 27.3625C109.95 27.3625 27.8625 109.587 27.8625 210.512C27.8625 311.437 110.087 393.662 211.012 393.662C311.937 393.662 394.162 311.437 394.162 210.512C394.162 109.587 312.075 27.3625 211.012 27.3625Z",
    fill: "url(#paint0_linear_744_13812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.162 108.9C154.362 108.9 146.112 113.575 141.712 121.275L119.575 159.637L100.188 193.187L97.4375 198C93.0375 205.7 93.0375 215.187 97.4375 222.75L100.188 227.562L119.575 261.112L141.712 299.612C146.112 307.312 154.362 311.987 163.162 311.987H263.675C282.787 311.987 294.75 291.362 285.125 274.725L284.437 273.487C280.037 265.787 271.787 261.112 262.987 261.112H175.675C161.925 261.112 150.925 249.975 150.925 236.362V184.25C150.925 170.5 162.062 159.5 175.675 159.5H263.125C271.925 159.5 280.175 154.825 284.575 147.125L285.262 145.887C294.75 129.387 282.925 108.625 263.812 108.625L163.162 108.9Z",
    fill: "url(#paint1_linear_744_13812)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_13812",
    x1: -0.946254,
    y1: -24.9363,
    x2: 506.258,
    y2: 420.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467672,
    stopColor: "#0065F2",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_744_13812",
    x1: 93.4695,
    y1: 96.5803,
    x2: 336.819,
    y2: 301.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467672,
    stopColor: "#0065F2",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_13812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421.025,
    height: 421.025,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3D);
export default __webpack_public_path__ + "static/media/Logo3D.07d38d0284eb2c20f23dc8f5aa394689.svg";
export { ForwardRef as ReactComponent };